import { useQuery } from '@tanstack/react-query';
import { getVendorOnboardingOrganizations } from '../../services';

export const vendorOrgKeys = {
  all: ['vendorOrganizations'] as const,
  onboarding: () => [...vendorOrgKeys.all, 'onboarding'] as const,
};

export function useVendorOnboardingOrganizations(enabled = true) {
  return useQuery({
    queryKey: vendorOrgKeys.onboarding(),
    queryFn: getVendorOnboardingOrganizations,
    enabled,
  });
}
